import React from 'react';
import { ApiTypes } from '@wix/social-groups-api/dist/src/types';
import { GroupTypeSelect } from '@wix/social-groups-common/dist/src/components';

import { DATA_HOOKS } from './dataHooks';

export interface GroupTypesProps {
  selectedType: ApiTypes.v1.GroupPrivacyLevel;
  onSelect(option: any): void;
}

const translations = {
  [ApiTypes.v1.GroupPrivacyLevel.PUBLIC]: {
    value: 'groups-web.types.public.name',
    subtitle: 'groups-web.types.public.description',
  },
  [ApiTypes.v1.GroupPrivacyLevel.PRIVATE]: {
    value: 'groups-web.types.private.name',
    subtitle: 'groups-web.types.private.description',
  },
  [ApiTypes.v1.GroupPrivacyLevel.SECRET]: {
    value: 'groups-web.types.secret.name',
    subtitle: 'groups-web.types.secret.description',
  },
};
export const GroupTypesDropdown: React.FC<GroupTypesProps> = (props) => {
  const { onSelect, selectedType } = props;
  return (
    <GroupTypeSelect
      onSelect={onSelect}
      selectedType={selectedType}
      translationKeys={translations}
      dataHook={DATA_HOOKS.groupsTypeDropdown}
    />
  );
};
